// Converts a File object (i.e. Blob) to a plain object (which is needed by redux)
export function toPlainObject(fileBlob) {
  const {
    lastModified,
    lastModifiedDate,
    name,
    size,
    type,
    webkitRelativePath,
  } = fileBlob
  return {
    lastModified,
    lastModifiedDate,
    name,
    size,
    type,
    webkitRelativePath,
  }
}

export function normalizeAttachment(attachment) {
  const file = attachment.file || {}
  return {
    ...attachment,
    file_name:
      (file && file.name) ||
      attachment.file_name ||
      attachment.filename ||
      file.type,
    file_type: attachment.file_type || attachment.content_type || file.type,
    file_size: attachment.file_size || file.size,
    key: attachment.key || attachment.id,
    url: attachment.expiringUrl || attachment.url,
  }
}
